export const WARNING_AFTER_N_MISSED_CALLS = 2;

export const MIN_CHANCE_OF_RAIN = 0.30; // 30% chance
